export default "__VITE_ASSET__CpuqK4Nx__"